<div class="my-7">
  <mat-form-field class="moneytor-input" [ngClass]="class">
    @if (label) {
      <mat-label>{{ label }}</mat-label>
    }
    <mat-select
      [name]="placeholder ? placeholder : label"
      [placeholder]="placeholder"
      [required]="required"
      [(ngModel)]="model"
      [disabled]="disabled"
      [multiple]="multiple"
      (selectionChange)="onChange($event.value)"
      #filterSelect="ngModel"
      >
      @if (multiple) {
        <mt-select-all
          [model]="filterSelect"
          [values]="items"
          (onSelectAll)="onSelectAll($event)"
          >
        </mt-select-all>
      }
      @for (option of items; track option) {
        <mat-option
          [value]="value ? option[value] : option"
          >
          {{ display ? option[display] : option }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  @if (
    filterSelect.invalid &&
    filterSelect.touched &&
    filterSelect.hasError('required')
    ) {
    <mat-error
      >This field is required*</mat-error
      >
    }
  </div>
